<template>
    <transition>
        <div class="swiper-item" :style="{'--direction':direction == 'next' ? '100%' : '-100%','--reDirection':direction == 'next' ? '-100%' : '100%'}"  v-show="selfIndex === currentIndex">
            <slot></slot>
        </div>
    </transition>
</template>
<script>
export default {
    data() {
        return {
            // 每一项轮播滑块下标 因为用的插槽无法直接传 所以通过this.$vnode.key方法获取
            selfIndex: this.$vnode.key,
            // 当前轮播滑块下标
            currentIndex: this.$parent.currentIndex,
            // 方向 点击指示点或点击方向事使用 默认next
            direction:this.$parent.direction
        }
    },
    watch: {
        '$parent.currentIndex'() {
            this.currentIndex = this.$parent.currentIndex
        },
        '$parent.direction'(){
            this.direction=this.$parent.direction
        }
    },
    methods: {

    },

}
</script>
<style lang="scss" scoped>
.swiper-item {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
}

.v-enter-active,
.v-leave-active {
    transition: all .3s linear;
}
.v-enter-active {
    transform: translateX(var(--direction));
    
}

.v-enter-to {
    transform: translateX(0);
}

.v-leave-active {
    transform: translateX(0);
}

.v-leave-to {
    transform: translateX(var(--reDirection));
}</style>  